import { Directive, TemplateRef } from '@angular/core';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[ngslCarouselDot]'
})
export class NgslCarouselDotDirective {
  isVisible = true;
  constructor(public tpl: TemplateRef<any>) {}
}
